{
  "cards": {
    "continue": "Continue",
    "start": "Start",
    "viewCourse": "View course",
    "previous": "Previous",
    "next": "Next",
    "goToSlide": "Go to slide {{number}}",
    "banner": "Banner",
    "percentComplete": "{{percent}}% complete",
    "percentCompleted": "{{percent}}% completed",
    "access": "Access",
    "previousBanner": "Previous banner",
    "nextBanner": "Next banner",
    "new": "New",
    "viewDetails": "View details",
    "review": "Review",
    "locked": "Locked",
    "completed": "Completed",
    "complete": "Complete",
    "restrictedAccess": "Restricted access",
    "scrollLeft": "Scroll left",
    "scrollRight": "Scroll right",
    "buy": "Buy",
    "unlock": "Unlock access"
  },
  "courseSections": {
    "relatedCourses": "Related courses",
    "noCourseSelected": "No course selected",
    "modules": "Modules",
    "noModuleSelected": "No module selected",
    "dragToReorder": "Drag to reorder",
    "progress": "Progress",
    "viewTrail": "View path",
    "lessonCount_one": "{{count}} lesson",
    "lessonCount_zero": "{{count}} lessons",
    "lessonCount_other": "{{count}} lessons"
  },
  "home": {
    "greeting": {
      "morning": "Good morning, <name>{{name}}</name>",
      "afternoon": "Good afternoon, <name>{{name}}</name>",
      "evening": "Good evening, <name>{{name}}</name>"
    },
    "defaultName": "Student",
    "loading": "Loading...",
    "quickLinks": {
      "courses": {
        "title": "My Courses",
        "description": "Access all your available courses"
      },
      "ranking": {
        "title": "Leaderboard",
        "description": "See your position and achievements"
      },
      "community": {
        "title": "Community",
        "description": "Connect with other students"
      },
      "certificates": {
        "title": "Certificates",
        "description": "Download your completion certificates"
      }
    },
    "subtitle": {
      "continue": "Pick up where you left off",
      "explore": "Explore your courses",
      "start": "Start your learning journey"
    },
    "stats": {
      "courses": "courses",
      "inProgress": "in progress",
      "completed": "completed"
    },
    "continueWatching": "Continue Watching",
    "continueLesson": "Lesson \"{{title}}\" · stopped at {{time}}",
    "quickAccess": "Quick Access",
    "continueLearning": "Keep Learning",
    "viewAll": "View all"
  },
  "courses": {
    "loading": "Loading courses...",
    "title": "Courses",
    "subtitle": "Explore all courses available on the platform",
    "courseCount_one": "{{count}} course",
    "courseCount_zero": "{{count}} courses",
    "courseCount_other": "{{count}} courses",
    "startCourse": "Start course",
    "emptyTitle": "No courses found",
    "emptyDescription": "Stay tuned for news!"
  },
  "course": {
    "notFoundTitle": "Course not found",
    "notFoundDescription": "The course you're looking for doesn't exist.",
    "backToCourses": "Back to courses",
    "lockedTitle": "Locked content",
    "lockedDescription": "You don't have access to this course yet. Get your spot to unlock every lesson.",
    "lockedNoCheckout": "This course is not available for purchase yet. Contact the creator to get access.",
    "buyNow": "Buy now",
    "changePlanTitle": "Plans for this course",
    "changePlanDescription": "Want to switch plans? When you subscribe to another plan, the current one ends and your access continues.",
    "choosePlan": "Choose this plan",
    "fromPrice": "from {{price}}"
  },
  "trail": {
    "startHere": "Start here!",
    "backToCourse": "Back to course",
    "title": "Learning Path",
    "modulesProgress_one": "<bold>{{completed}}</bold>/{{count}} module",
    "modulesProgress_zero": "<bold>{{completed}}</bold>/{{count}} modules",
    "modulesProgress_other": "<bold>{{completed}}</bold>/{{count}} modules",
    "start": "Path start",
    "completed": "Path completed!",
    "end": "Path end",
    "emptyTitle": "No modules available",
    "emptyDescription": "This course doesn't have any modules yet."
  },
  "ranking": {
    "loading": "Loading leaderboard...",
    "title": "Leaderboard",
    "subtitle": "Earn points, level up and stand out among the best",
    "rankBadge": "#{{rank}} on the leaderboard",
    "howItWorks": "How does it work?",
    "stats": {
      "totalXp": "Total XP",
      "accumulatedPoints": "points earned",
      "level": "Level",
      "defaultLevel": "Beginner",
      "position": "Position",
      "overallRanking": "on the overall leaderboard",
      "streak": "Streak",
      "consecutiveDays": "consecutive days"
    },
    "achievements": {
      "title": "Achievements",
      "unlocked": "{{unlocked}} of {{total}} unlocked"
    },
    "leaderboard": {
      "title": "Leaderboard",
      "subtitle": "The top students on the platform"
    },
    "periods": {
      "all": "All time",
      "monthly": "Monthly",
      "weekly": "Weekly"
    },
    "anonymous": "Anonymous",
    "you": "You",
    "pagination": {
      "previous": "Previous",
      "next": "Next",
      "pageOf": "{{page}} of {{total}}"
    },
    "empty": {
      "title": "Leaderboard is empty",
      "description": "Complete lessons to earn points and show up here!"
    },
    "emptyPeriod": {
      "title": "Nobody has scored in this period yet",
      "description": "Complete lessons to earn points and show up here!"
    },
    "explanationTitle": "How does gamification work?",
    "howItWorksModal": {
      "xpPerAction": "XP per action",
      "xpPerLevel": "XP per level",
      "learning": "Learning",
      "community": "Community",
      "level": "Level",
      "fromXp": "From {{xp}}",
      "dailyLimit": "(up to {{count}} per day)",
      "courseProgress": "Reached {{percent}}% of the course"
    }
  },
  "achievements": {
    "title": "Achievements",
    "subtitle": "Track your progress and unlock epic achievements",
    "stats": {
      "points": "Points",
      "defaultLevel": "Beginner",
      "streak": "Streak",
      "ranking": "Rank"
    },
    "levelProgress": {
      "title": "Level Progress",
      "level": "Level {{level}}: {{name}}",
      "pointsNeeded": "<highlight>{{points}}</highlight> points to the next level"
    },
    "tabs": {
      "achievements": "Achievements",
      "ranking": "Leaderboard"
    },
    "unlockedSummary": "<highlight>{{unlocked}}</highlight> of <mono>{{total}}</mono> achievements unlocked",
    "leaderboard": {
      "title": "Top 10 - Overall Leaderboard",
      "defaultUser": "User",
      "empty": "No users on the leaderboard yet.",
      "yourPosition": "Your position"
    }
  },
  "community": {
    "title": "Community",
    "subtitle": "Community and Interaction",
    "enterDescription": "Ask questions, share what you are learning and talk with other students. You are signed in automatically with your member area account.",
    "enterButton": "Enter the community",
    "entering": "Entering...",
    "enterError": "Could not enter the community. Please try again.",
    "unavailable": "The community is not available yet."
  },
  "certificates": {
    "title": "My Certificates",
    "subtitle": "Your course completion certificates",
    "completionCertificate": "Certificate of Completion",
    "issuedOn": "Issued on {{date}}",
    "view": "View certificate",
    "download": "Download",
    "validate": "Validate certificate",
    "emptyTitle": "No certificates yet",
    "emptyDescription": "Complete your courses to receive completion certificates.",
    "viewMyCourses": "View my courses",
    "verificationTitle": "Authenticity Verification",
    "verificationDescription": "Every certificate has a unique verification code. Anyone can check the authenticity of your certificate through our verification page.",
    "verifyLink": "Verify a certificate →",
    "pendingTitle": "Completed courses",
    "pendingDescription": "You completed these courses. Generate your certificate.",
    "generate": "Generate certificate",
    "generated": "Certificate generated!",
    "generateError": "Could not generate the certificate. Please try again.",
    "notAvailableYet": "The school has not enabled the certificate for this course yet. Please try again later."
  },
  "profile": {
    "toasts": {
      "nameRequired": "Name cannot be empty",
      "profileUpdated": "Profile updated successfully!",
      "profileUpdateError": "Error updating profile",
      "unsupportedImageFormat": "Unsupported image format. Use JPG, PNG, GIF or WebP.",
      "imageTooLarge": "The image must be 5MB or less",
      "imageUrlMissing": "Image URL was not returned",
      "photoUpdated": "Photo updated successfully!",
      "photoUpdateError": "Error updating photo. Please try again."
    },
    "title": "My Account",
    "subtitle": "Manage your profile information and settings",
    "level": "Level",
    "avatar": {
      "save": "Save photo",
      "change": "Change photo"
    },
    "personal": {
      "title": "Personal Details",
      "description": "Fill in your main details",
      "fullName": "Full name *",
      "fullNamePlaceholder": "Your full name",
      "email": "Email",
      "emailReadOnly": "Email can't be changed",
      "phone": "Mobile/WhatsApp",
      "birthDate": "Date of birth",
      "occupation": "Occupation",
      "occupationPlaceholder": "E.g.: Full Stack Developer",
      "bio": "Bio (optional)",
      "bioPlaceholder": "Tell us a bit about yourself..."
    },
    "address": {
      "title": "Address",
      "zipCode": "ZIP code",
      "zipCodePlaceholder": "00000",
      "state": "State",
      "statePlaceholder": "NY",
      "city": "City",
      "cityPlaceholder": "New York",
      "neighborhood": "Neighborhood",
      "street": "Street, avenue...",
      "number": "Number",
      "complement": "Address line 2",
      "complementPlaceholder": "Apt, suite..."
    },
    "social": {
      "title": "Social Media",
      "usernamePlaceholder": "@yourusername"
    },
    "customFields": {
      "title": "Additional Information",
      "selectPlaceholder": "Select"
    },
    "saving": "Saving...",
    "saveChanges": "Save changes"
  }
}
